import { getSeedance25ReferenceMediaType, getSeedance25ReferenceUrl, isModelArkSeedance25Provider, normalizeSeedance25Provider } from './seedance25Capabilities';
import { DOMESTIC_SEEDANCE_LIBRARY_PROVIDER, isDomesticOfficialSeedance } from './domesticSeedanceCapabilities';
export const getModelArkLibraryProvider = (provider) => isDomesticOfficialSeedance(provider) ? DOMESTIC_SEEDANCE_LIBRARY_PROVIDER : normalizeSeedance25Provider(provider) || provider;
export const usesModelArkAssetLibrary = (provider) => isDomesticOfficialSeedance(provider) || isModelArkSeedance25Provider(provider);

export const MODELARK_LIBRARIES = Object.freeze([
  { provider: 'volcengine_sd25', label: '国内库', model: 'Seedance 官方' },
  { provider: 'byteplus_sd25', label: '海外库', model: 'Dreamina 2.5' },
]);
export const MODELARK_ASSET_STATUS = Object.freeze({
  NotRegistered: '未入库', Pending: '排队中', Processing: '处理中', Active: '已就绪',
  Failed: '入库失败', Unknown: '待核查', Unavailable: '不可用',
});
export const modelArkReferenceKey = ({ url, mediaType = 'Image' }, provider = '') => `${provider}\n${mediaType}\n${url}`;
export const normalizeModelArkReferences = (references = []) => {
  const seen = new Set();
  return (Array.isArray(references) ? references : []).flatMap((item) => {
    const url = getSeedance25ReferenceUrl(item).trim();
    if (!/^https?:\/\//i.test(url)) return [];
    const type = getSeedance25ReferenceMediaType(item);
    const mediaType = type[0].toUpperCase() + type.slice(1);
    const reference = { url, mediaType };
    const key = modelArkReferenceKey(reference);
    if (seen.has(key)) return [];
    seen.add(key);
    return [reference];
  });
};
export const collectWorkshopModelArkReferences = (assets = []) => normalizeModelArkReferences(
  assets.flatMap((asset) => [asset, ...(Array.isArray(asset.variations) ? asset.variations : [])]),
);
export const canRegisterModelArkAsset = (status, retryFailed = false) => (
  status === 'NotRegistered' || (retryFailed && status === 'Failed')
);
export const canRecheckModelArkAsset = (record) => (
  record?.status === 'Unknown' && record?.canRecheck === true
);

// Only a completed current-library snapshot can make a reference look ready.
// Legacy IDs/metadata on the reference itself are deliberately not consulted.
export const getModelArkReferenceState = (registry, item) => {
  const reference = normalizeModelArkReferences([item])[0];
  const record = reference ? registry.getStatus(reference) : undefined;
  const libraryLabel = MODELARK_LIBRARIES.find((library) => library.provider === registry.provider)?.label || '当前库';
  const readError = registry.readError ?? registry.error;
  const status = !reference ? 'MissingOriginal'
    : readError ? 'ReadError'
      : registry.targetConfiguration?.configured === false ? 'Unavailable'
        : !record ? (registry.loading ? 'Loading' : 'Unknown')
          : registry.targetConfiguration?.configured !== true ? 'Unknown'
            : record.status;
  return { reference, record, libraryLabel, status };
};
